import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Comments.scss";
import DeleteIcon from "@mui/icons-material/Delete";
import AddComment from "../addComment/AddComment";
import mockupData from "../../database-mockup.json";

function Comments({ foundComments }) {
  const timeFormat = (time) => {
    const date = new Date(time);
    const d = date.toLocaleDateString();
    const t = date.toLocaleTimeString();
    return d + ` ` + t;
  };
  const deleteHandler = () => {
    console.log("delete");
  };
  const users = mockupData.usersData;
  const findUserById = (userId) => {
    const id = Number(userId);
    const result = users.find((user) => user.id === id);

    if (result) {
      return result.username;
    } else {
      return "Unknown User";
    }
  };

  const findUserImageById = (userId) => {
    const id = Number(userId);
    const result = users.find((user) => user.id === id);

    if (result && result.image) {
      return `../upload/${result.image}`;
    } else {
      return `../upload/default-image.jpeg`; // Provide a default image or handle accordingly
    }
  };

  return (
    <>
      <div className="comment">
        {/* <AddComment comments={comments} /> */}
        {foundComments.map((comment, index) => {
          return (
            <div className="commentContainer" key={index}>
              <div className="comment__user">
                <img
                  className="comment__user__img"
                  src={`../upload/${findUserImageById(comment.userID)}`}
                  alt="user"
                />
                <span className="comment__user__name">
                  {findUserById(comment.userID)}
                </span>
                <span className="comment__user__date">
                  {timeFormat(comment.createdAt)}
                </span>
                <button
                  className="comment__btn comment__btn"
                  onClick={() => deleteHandler(comment.id)}
                >
                  <DeleteIcon />
                </button>
              </div>

              <div className="comment__text">
                <p className="comment__text__msg">{comment.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default Comments;
